import { Modal } from "@mantine/core";
import { useDisclosure } from "@mantine/hooks";
import { useEffect } from "react";
import { Button } from "src/components/shared/Button/Button";
import { backBodySvg } from "src/mock/interavticeSvgs/body/backBodySvg";
import { frontBodySvg } from "src/mock/interavticeSvgs/body/frontBodySvg";
import { useDispatch, useSelector } from "src/redux/hooks";
import {
  setBodyPartModalData,
  setBodyPartPreviewModalData,
} from "src/redux/slices/generatorFeaturesSlice";
import { Flex } from "src/styled";

import BodyPartDiagram from "./BodyPartDiagram";

interface Props {
  notEditable?: boolean;
}
const BodyPartPreviewModal = ({ notEditable }: Props) => {
  const dispatch = useDispatch();
  const { bodyPartPreviewModalData: data } = useSelector(
    state => state.generatorFeaturesSlice,
  );
  const [opened, { open, close }] = useDisclosure(false);

  useEffect(() => {
    if (data) {
      open();
    } else close();
  }, [data, close, open]);

  if (!data) return null;

  const handleClose = () => {
    dispatch(setBodyPartPreviewModalData(null));
  };

  const filteredData = data.value.filter(
    el =>
      el.type === data.selectedType && el.selectedPart === data.selectedName,
  );
  const handleEdit = () => {
    dispatch(
      setBodyPartModalData({ value: data.value, inputId: data.inputId ?? "" }),
    );
    handleClose();
  };
  return (
    <Modal onClose={handleClose} opened={opened} title={data?.selectedName}>
      <Flex justify="center">
        <BodyPartDiagram
          svgFile={data?.selectedType === "front" ? frontBodySvg : backBodySvg}
          preview
          selectedParts={filteredData}
          type={data?.selectedType}
        />
      </Flex>
      {!notEditable && (
        <Flex justify="flex-end" mt={10}>
          <Button onClick={handleEdit}>Edit</Button>
        </Flex>
      )}
    </Modal>
  );
};
export default BodyPartPreviewModal;
